"use client";

import React from "react";
import { CollapsibleSection } from "@/components/shared/CollapsibleSection";
import type { Time_Entries } from "@/src/gql/graphql";

import { formatMetadataTimestamp } from "../time-entry-details-utils";

/** Collapsed-by-default "Metadata" section — created + last-updated timestamps. */
export function MetadataSection({ item }: { item: Time_Entries }) {
  return (
    <CollapsibleSection title="Metadata" defaultCollapsed>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-gray-500">Created</label>
          <p className="text-sm text-card-foreground mt-1">
            {formatMetadataTimestamp(item.created_at)}
          </p>
        </div>
        <div>
          <label className="text-sm font-medium text-gray-500">Last Updated</label>
          <p className="text-sm text-card-foreground mt-1">
            {formatMetadataTimestamp(item.updated_at)}
          </p>
        </div>
      </div>
    </CollapsibleSection>
  );
}
